<template>
    <div>
        <Breadcrumbs title="Dashboard"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row ">
                <div v-if="userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-cart" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Shops</span>
                          <h4 class="mb-0 counter">{{ shops.length }}</h4><feather type="shopping-cart" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-info static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> {{ userAdmin ? 'Sign ups' : 'Customers' }}  </span>
                          <h4 class="mb-0 counter">{{ users.length }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-bag" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Visits</span>
                          <h4 class="mb-0 counter">{{ visits.length }}</h4><feather type="shopping-bag" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div v-if="!userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-info static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Rated</span>
                          <h4 class="mb-0 counter"> {{ rated }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="box" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Products</span>
                          <h4 class="mb-0 counter"> {{ products.length }} </h4><feather type="box" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-xl-8 box-col-12 xl-100">
                  <div class="row dash-chart">
                    <div class="col-xl-6 box-col-6 col-md-6">
                      <px-card slot="headerAction">
                        <div slot="headerCustom">
                          <div class="media">
                            <div class="media-body">
                                    <p><span class="f-w-500 font-roboto">Customer Visit Graph</span>
                                      <!-- <span class="f-w-700 font-primary ml-2">89.21%</span> -->
                                    </p>
                                    <h4 class="f-w-500 mb-0 f-26"><span class="counter">Totals: {{ users.length+', '+visits.length }}</span></h4>
                                  </div>
                          </div>
                        </div>
                        <div>
                          <div class="media">
                            <div class="media-body">
                              <div class="profit-card">
                                <div id="spaline-chart">
                                  <apexchart
                                    height="150"
                                    type="area"
                                    :options="apexTotalsale.options"
                                    :series="apexTotalsale.series"
                                  ></apexchart>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </px-card>
                    </div>
                    <div class="col-xl-6 box-col-6 col-md-6">
                      <div class="card o-hidden">
                        <div class="card-header card-no-border">
                          <div class="card-header-right">
                            <ul class="list-unstyled card-option">
                              <li>
                                <i class="fa fa-spin fa-cog"></i>
                              </li>
                              <li>
                                <i class="view-html fa fa-code"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-maximize full-card"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-minus minimize-card"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-refresh reload-card"></i>
                              </li>
                              <li>
                                <i class="icofont icofont-error close-card"></i>
                              </li>
                            </ul>
                          </div>
                          <div class="media">
                            <div class="media-body">
                              <p>
                                <span class="f-w-500 font-roboto"> Total Reviews</span>
                                <!-- <span class="f-w-700 font-primary ml-2">35.00%</span> -->
                              </p>
                              <h4 class="f-w-500 mb-0 f-26 counter">Total: {{ visits.filter(v=> v.comment !== "").length }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="card-body pt-0">
                          <div class="monthly-visit">
                            <div id="column-chart">
                              <apexchart
                                height="105"
                                type="bar"
                                :options="apexTotalvisit.options"
                                :series="apexTotalvisit.series"
                              ></apexchart>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div class="col-xl-4 box-col-12 xl-50">
                  <div class="card o-hidden dash-chart">
                    <div class="card-header card-no-border">
                      <div class="card-header-right">
                        <ul class="list-unstyled card-option">
                          <li>
                            <i class="fa fa-spin fa-cog"></i>
                          </li>
                          <li>
                            <i class="view-html fa fa-code"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-maximize full-card"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-minus minimize-card"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-refresh reload-card"></i>
                          </li>
                          <li>
                            <i class="icofont icofont-error close-card"></i>
                          </li>
                        </ul>
                      </div>
                      <div class="media">
                        <div class="media-body">
                          <p>
                            <span class="f-w-500 font-roboto">Shopnscan</span>
                            <!-- <span class="font-primary f-w-700 ml-2">99.00%</span> -->
                          </p>
                          <h4 class="f-w-500 mb-0 f-26 mb-3">
                            <span class="counter">Welcome</span>
                          </h4>
                          <p>Need any assistance <a href="mailto:hello@shopnscan.app">hello@shopnscan.app</a></p>
                          <p class="mb-0">Our Website <a href="https://shopnscan.app">www.shopnscan.app</a></p>
                          <!-- <p class="mb-0">Contact us: <a href="tel:+233241026572">+233241026572</a></p> -->
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0">
                      <div class="negative-container">
                        <div id="negative-chart">
                          <!-- <apexchart
                            height="320"
                            type="bar"
                            :options="apexTotalprofit.options"
                            :series="apexTotalprofit.series"
                          ></apexchart> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row second-chart-list third-news-update">
              <div v-if="!userAdmin" class="col-xl-4 xl-50 appointment box-col-6">
                      <px-card :actions="false">
                        <div slot="headerCustom">
                          <div class="header-top">
                            <h5 class="m-0">Preferences</h5>
                            <div class="card-header-right-icon">
                              <select class="button btn btn-primary">
                                <option>Year</option>
                                <!-- <option>Tomorrow</option> -->
                                <!-- <option>Yesterday</option> -->
                              </select>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="radar-chart">
                            <div id="marketchart">
                              <apexchart
                              v-if="pref"
                                height="380"
                                type="radar"
                                :options="apexMarketValue.options"
                                :series="apexMarketValue.series"
                              ></apexchart>
                            </div>
                          </div>
                        </div>
                      </px-card>
                    </div>
                    <div class="col-xl-4 col-lg-12 xl-50 calendar-sec box-col-6">
                      <px-card>
                        <div slot="with-padding" class="chat-box">
                            <div class="setting-dot">
                            <div class="setting-bg-primary date-picker-setting position-set pull-right">
                              <i class="fa fa-spin fa-cog"></i>
                            </div>
                          </div>
                          <functional-calendar></functional-calendar>
                        </div>
                      </px-card>
                    </div>
                    <div class="col-xl-4 xl-100 chat-sec box-col-6">
                      <px-card :actions="false" class="chat-default">
                        <div slot="headerCustom">
                          <div class="media media-dashboard">
                            <div class="media-body">
                              <h5 class="mb-0">Alerts & Tips</h5>
                            </div>
                            <div class="icon-box">
                              <i class="fa fa-ellipsis-h"></i>
                            </div>
                          </div>
                        </div>
                        <div class="card-body new-update ">
                            <div class="activity-timeline">
                              <div class="media">
                                <div class="activity-line"></div>
                                <div class="activity-dot-secondary"></div>
                                <div class="media-body">
                                  <span>Hurrey</span>
                                  <p class="font-roboto">You are welcome to Shopnscan.</p>
                                </div>
                              </div>
                              <div class="media">
                                <div class="activity-dot-primary"></div>
                                <div class="media-body">
                                  <span>Shopnscan
                                    <i
                                      class="fa fa-circle circle-dot-secondary pull-right"
                                    ></i>
                                  </span>
                                  <p class="font-roboto">Kindly entreat visitors to rate their shopping experience.</p>
                                </div>
                              </div>
                              <div class="media">
                                <div class="activity-dot-secondary"></div>
                                <div class="media-body">
                                  <span>
                                    Products & Offers
                                    <i
                                      class="fa fa-circle circle-dot-primary pull-right"
                                    ></i>
                                  </span>
                                  <p class="font-roboto">Post your offering to increase your traction and comversions </p>
                                </div>
                              </div>
                              <div class="media">
                                <div class="activity-dot-primary"></div>
                                <div class="media-body">
                                  <span>
                                    Let us know
                                    <i
                                      class="fa fa-circle circle-dot-primary pull-right"
                                    ></i>
                                  </span>
                                  <p class="font-roboto">We are available. Let us know.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </px-card>
                    </div>
                    
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>

import axios from 'axios'
import moment  from 'moment';

var primary = localStorage.getItem("primary_color") || "#7366ff";
var secondary = localStorage.getItem("secondary_color") || "#f73164";
// var Knob = require("knob");

// var ordervalue = Knob({
//   value: 35,
//   angleOffset: 90,
//   className: "review",
//   thickness: 0.2,
//   width: 65,
//   height: 65,
//   fgColor: primary,
// });
// var productvalue = Knob({
//   value: 60,
//   angleOffset: 90,
//   className: "review",
//   thickness: 0.2,
//   width: 65,
//   height: 65,
//   fgColor: primary,
// });
// import * as Chartist from "chartist";

export default {
    data() {
        return {
        shops: [],
        visits: null,
        users: null,
        rated: 0,
        products: [],
        pref: null,
        events: [
        {
            title  : 'event1',
            start  : '2010-01-01',
        },
        {
            title  : 'event2',
            start  : '2010-01-05',
            end    : '2010-01-07',
        },
        {
            title  : 'event3',
            start  : '2010-01-09T12:30:00',
            allDay : false,
        },
      ],
      apexTotalsale: {
        options: {
          chart: {
            height: 150,
            type: "area",
            toolbar: {
              show: false,
            },
          },
          colors: [primary, secondary],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 0,
          },
          xaxis: {
            // type: "datetime",
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          yaxis: {
            low: 0,
            offsetX: 0,
            offsetY: 0,
            show: false,
            labels: {
              low: 0,
              offsetX: 0,
              show: false,
            },
            axisBorder: {
              low: 0,
              offsetX: 0,
              show: false,
            },
          },
          fill: {
            type: "gradient",
            opacity: [1, 0.4, 0.25],
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 1,
              gradientToColors: ["#a26cf8", "#a927f9", primary],
              opacityFrom: [1, 0.4, 0.25],
              opacityTo: [1, 0.4, 0.25],
              stops: [30, 100],
              colorStops: [],
            },
            // colors: [primary, primary, primary],
            colors: [primary, primary],
          },
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm",
            },
          },
          legend: {
            show: false,
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: -20,
              top: 0,
              bottom: -40,
            },
          },
        },
        series: [
          {
            name: "Customers",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Visits",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          // {
          //   name: "Rate",
          //   data: [450, 150, 320, 500, 280, 100,450, 150, 320, 500, 280, 100],
          // },
        ],
      },
      apexTotalvisit: {
        options: {
          chart: {
            height: 105,
            type: "bar",
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
              columnWidth: "20%",
              startingShape: "rounded",
              endingShape: "rounded",
            },
          },
          colors: [primary],
          dataLabels: {
            enabled: false,

            formatter: function (val) {
              return val + "%";
            },
            offsetY: -10,
            style: {
              fontSize: "12px",
              colors: [primary],
            },
          },
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
            position: "bottom",

            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            crosshairs: {
              fill: {
                type: "gradient",
                gradient: {
                  colorFrom: primary,
                  colorTo: secondary,
                  stops: [0, 100],
                  opacityFrom: 0.4,
                  opacityTo: 0.5,
                },
              },
            },
            tooltip: {
              enabled: true,
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function (val) {
                return val;
              },
            },
          },
          grid: {
            show: false,
            padding: {
              top: -35,
              right: -10,
              bottom: -5,
              left: -10,
            },
          },
        },
        series: [
          {
            name: "Reviews ",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      apexDashboard: {
        options: {
          chart: {
            width: 685,
            height: 240,
            type: "area",
            toolbar: {
              show: false,
            },
          },
          colors: [primary, secondary],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          xaxis: {
            type: "category",
            low: 0,
            offsetX: 0,
            offsetY: 0,
            show: false,
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
              "Jan",
            ],
            labels: {
              low: 0,
              offsetX: 0,
              show: false,
            },
            axisBorder: {
              low: 0,
              offsetX: 0,
              show: false,
            },
          },
          yaxis: {
            low: 0,
            offsetX: 0,
            offsetY: 0,
            show: false,
            labels: {
              low: 0,
              offsetX: 0,
              show: false,
            },
            axisBorder: {
              low: 0,
              offsetX: 0,
              show: false,
            },
          },
          markers: {
              strokeWidth: 3,
              colors: "#ffffff",
              strokeColors: [ primary , secondary ],
              hover: {
                  size: 6,
              }
          },
          fill: {
              type: 'gradient',
              gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.5,
                  stops: [0, 80, 100]
              }
          },
          legend: {
        show: false,
    },
    tooltip: {
        x: {
            format: 'MM'
        },
    },
          grid: {
              show: false,
              padding: {
                  left: 0,
                  right: 0,
                  bottom: -15,
                  top: -40
              }
          },
        },
        series: [
          {
            name: "series1",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "series2",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      apexMarketValue: {
        options: {
          chart: {
            width: 505,
            height: 380,
            type: "radar",
            toolbar: {
              show: false,
            },
          },
          colors: [primary],
          dataLabels: {
            enabled: false,
          },
          labels: 
          // this.getPrefs.map(p=> p.cat)
          [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ]
          ,
          stroke: {
            width: 3,
            curve: "smooth",
          },
          plotOptions: {
            radar: {
              size: 140,
              polygons: {
                fill: {
                  colors: ["#fcf8ff", "#f7eeff"],
                },
              },
            },
          },
          markers: {
            size: 6,
            colors: ["#fff"],
            strokeColor: [primary],
            strokeWidth: 3,
          },
          yaxis: {
            tickAmount: 7,
            labels: {
              formatter: function (val, i) {
                if (i % 2 === 0) {
                  return val;
                } else {
                  return "";
                }
              },
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val+'%';
              },
            },
          },
        },
        series: [
          {
            name: "Market value",
            data: [0, 0, 0, 0, 0, 0, 0],
            // data: this.getPrefs.map(p=> p.value)
          },
        ],
      }
        }
    },
    mounted() {
    // document.getElementById("ordervalue").append(ordervalue);
    // document.getElementById("productvalue").append(productvalue);
  },
  watch: {
    pref() {
      if (this.pref) {
        this.apexMarketValue.options.labels = this.getPrefs.map(p=> p.cat)
        this.apexMarketValue.series[0].data = this.getPrefs.map(p=> p.value)
      }
    },
    users() {
      //
      if (this.users) {
        //
        let record1 = []

        this.getYear().forEach(month => {
          //
          record1.push(this.users.filter(u=> u.date.includes(month.substring(0,7))).length)
          
        });

        // this.apexTotalsale.options.labels = this.getPrefs.map(p=> p.cat)
        this.apexTotalsale.series[0].data = record1
        
      }
    },
    visits() {
      //
      if (this.visits) {
        let record3 = []
        let record2 = []
        
        this.getYear().forEach(month => {
          //
          record2.push(this.visits.filter(v=> v.date.includes(month.substring(0,7))).length)
          record3.push(this.visits.filter(v=> v.comment !== "" && v.date.includes(month.substring(0,7))).length)

        });
        
        this.apexTotalsale.series[1].data = record2
        this.apexTotalvisit.series[0].data = record3
      }
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()

      },
      { immediate: true }

    )

  },
  computed: {
    userAdmin() {
      return localStorage.getItem('type') == "admin" ? true : false
    },
    getUser() {
      return this.$store.getters['authentication/getUser']
    },
    getPrefs() {

      const data = this.users

      let pref = []

      for (let index = 0; index < data.length; index++) {

        pref.push(data[index].preferences)
                        
      }

      let allpref = pref.flat()

      let array = []

      for (let index = 0; index < this.getUser.categories.length; index++) {
        //
        let c = 0;

        allpref.forEach(v=>v === this.getUser.categories[index] && c++)
                      
        array.push ({ cat: this.getUser.categories[index], value: (c/this.users.length) * 100 });

      }
                    
      array.sort(function(a, b) {
        return parseFloat(b.value) - parseFloat(a.value);
      });

      // this.pref = array

      return array

      },
  },
  methods: {
    fetchData() {

     const url = this.userAdmin ? '/users/' : '/users/'+this.getUser.name

      axios.get(url)
        .then(response=>{
          //
          this.users = response.data

          let pref = []

          for (let index = 0; index < this.users.length; index++) {
            

            const shop = this.users[index].shops.find(shop => shop.shop == this.getUser.name)

            if (shop) {
                this.users[index].preferences = shop.preferences
            }

            pref.push(this.users[index].preferences)

            this.users[index].date = this.userAdmin ? (new Date(this.users[index].createdAt)).toISOString() : (new Date(this.users[index].shops.find(s=>s.shop == this.getUser.name).createdAt)).toISOString()
            
          }


          let allpref = pref.flat()

          let array = []

          for (let index = 0; index < this.getUser.categories.length; index++) {
            //
            let c = 0;

            allpref.forEach(v=>v === this.getUser.categories[index] && c++)
                          
            array.push ({ cat: this.getUser.categories[index], value: c });

          }
                        
          array.sort(function(a, b) {
            return parseFloat(b.value) - parseFloat(a.value);
          });

          this.pref = array

          // return array


        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

      axios.get('/Shop')
        .then(response=>{
          //
          this.shops = response.data

        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

        const url2 = this.userAdmin ? '/visit/' : '/visit/'+this.getUser.name

      axios.get(url2)
        .then(response=>{
          //
          this.visits = response.data

            for (let index = 0; index < this.visits.length; index++) {

                          // date
                          if (this.visits[index].createdAt) {
                            this.visits[index].date = (new Date(this.visits[index].createdAt)).toISOString()
                          }
                          
                      }


          // if (!this.userAdmin) {
          //   for (let index = 0; index < this.visits.length; index++) {
          //       // const element = array[index];
          //       const rateLen = this.visits[index].rate.length

          //       if (rateLen > 0) {
          //       // sum rate
          //       const rate = (this.visits[index].rate.reduce((a, b) => a + b, 0)) / rateLen
          //       // to 2 decimalplaces
          //       this.visits[index].rate = parseFloat(rate.toFixed(1))

          //       // data.push(data[index])
          //       } else {
          //         this.visits[index].rate = 0
          //       }
          //   }
          // }

          const rateLen = this.visits.length

          //
          this.rated = ((response.data.reduce((a, b) => a + b.rate, 0)) / rateLen).toFixed(1)

        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })


        const url3 = this.userAdmin ? '/products/' : '/products/'+this.getUser.name

        axios.get(url3)
          .then(response=>{
            //
            this.products = response.data

          })
          .catch( e => {
            this.$swal({
              title:"Failed!",
              text:e.response.data,
              type:'error'
            });
          })
    },
    getYear(year) {

      var firstmonth = year ? year+"-01-01" :  new Date().getFullYear()+"-01-01"
      // var lastday = new Date(curr.setDate(last)).toDateString().substring(4);

      let months =[]
      //
      for (let index = 0; index < 12; index++) {

        const d = moment(firstmonth).add(index, 'months').toDate().toISOString().substring(0,10)
        
        months.push(d)
      }

      // console.log(days)
      return months

      }
  }
}
</script>